"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPayrollAttendanceShiftAndAbsenceRow = exports.isPayrollAttendanceAndShiftRow = exports.isPayrollAttendanceRow = exports.isPayrollShiftAndAbsenceRow = exports.isPayrollAbsenceRow = exports.isPayrollShiftRow = exports.isPayrollAvailabilityRow = exports.isPayrollAvailability = exports.isPayrollAbsence = exports.isPayrollOvertimeCollection = exports.isPayrollShiftWithAbsence = exports.isPayrollShift = exports.isPayrollLocationAttendance = exports.getPayrollSession = exports.getSessionKey = exports.mergeRawPayrollLocationData = exports.mergeRawPayrollData = exports.splitEmployeesIntoPackages = exports.getNumberOfEmployeesInPackage = exports.applyRounding = exports.applyTolerance = exports.getTimestampsForHourlyAbsence = void 0;
var moment_1 = __importDefault(require("moment"));
var datetime_1 = require("./datetime");
var getTimestampsForHourlyAbsence = function (absence) {
    var absence_hours = absence.absence_hours, from = absence.from;
    var _a = __read(absence_hours.split('-'), 2), fromHour = _a[0], toHour = _a[1];
    var hoursCrossMidnight = toHour < fromHour;
    var formattedFromDate = (0, moment_1.default)(from).format('YYYY-MM-DD');
    var formattedToDate = (0, moment_1.default)(formattedFromDate)
        .add(hoursCrossMidnight ? 1 : 0, 'days')
        .format('YYYY-MM-DD');
    return { from: "".concat(formattedFromDate, " ").concat(fromHour), to: "".concat(formattedToDate, " ").concat(toHour) };
};
exports.getTimestampsForHourlyAbsence = getTimestampsForHourlyAbsence;
var applyTolerance = function (attendanceTimestamp, shiftTimestamp, type, payrollSettings, isAttendanceAccepted, relevantHourlyAbsences) {
    if (isAttendanceAccepted === void 0) { isAttendanceAccepted = false; }
    if (relevantHourlyAbsences === void 0) { relevantHourlyAbsences = []; }
    if (!attendanceTimestamp)
        return attendanceTimestamp;
    var earlyStartTolerance = Number(payrollSettings.startTolerance);
    var lateEndTolerance = Number(payrollSettings.endTolerance);
    var lateStartTolerance = Number(payrollSettings.lateStartTolerance);
    var earlyEndTolerance = Number(payrollSettings.earlyEndTolerance);
    var diff = (0, datetime_1.calculateDurationBetweenTimestampsWithFractions)(attendanceTimestamp, shiftTimestamp);
    if (type === 'start') {
        if (diff < 0 && diff * -1 <= earlyStartTolerance && !isAttendanceAccepted) {
            return shiftTimestamp;
        }
        if (diff > 0 && diff <= lateStartTolerance) {
            var latestAbsenceDuringToleranceHours = relevantHourlyAbsences
                .map(exports.getTimestampsForHourlyAbsence)
                .filter(function (absenceTimestamps) {
                var from = absenceTimestamps.from, to = absenceTimestamps.to;
                return shiftTimestamp < to && shiftTimestamp >= from;
            })
                .sort(function (a, b) { return (a.from > b.from ? 1 : -1); })[0];
            if (latestAbsenceDuringToleranceHours) {
                var absenceTo = latestAbsenceDuringToleranceHours.to;
                return absenceTo < attendanceTimestamp ? absenceTo : attendanceTimestamp;
            }
            return shiftTimestamp;
        }
        return attendanceTimestamp;
    }
    if (diff > 0 && diff <= lateEndTolerance && !isAttendanceAccepted) {
        return shiftTimestamp;
    }
    if (diff < 0 && diff * -1 <= earlyEndTolerance) {
        var earliestAbsenceDuringToleranceHours = relevantHourlyAbsences
            .map(exports.getTimestampsForHourlyAbsence)
            .filter(function (absenceTimestamps) {
            var from = absenceTimestamps.from;
            return shiftTimestamp > from;
        })
            .sort(function (a, b) { return (a.from < b.from ? 1 : -1); })[0];
        if (earliestAbsenceDuringToleranceHours) {
            var absenceFrom = earliestAbsenceDuringToleranceHours.from;
            return absenceFrom > attendanceTimestamp ? absenceFrom : attendanceTimestamp;
        }
        return shiftTimestamp;
    }
    return attendanceTimestamp;
};
exports.applyTolerance = applyTolerance;
// This function is called calculatePayrollHour in frontend code
var applyRounding = function (hour, settings, t) {
    if (!hour)
        return hour;
    var setting;
    var type;
    if (t === 'start') {
        setting = settings.startRoundingSetting;
        type = settings.startRoundingType;
    }
    else {
        setting = settings.endRoundingSetting;
        type = settings.endRoundingType;
    }
    var minutes = parseInt(hour.split(':')[0].slice(-2)) * 60 + parseInt(hour.split(':')[1]);
    var reminder = minutes % setting.roundNum;
    var rest = minutes - reminder;
    if (reminder > 0) {
        switch (type.type) {
            case 'math': {
                if (reminder >= setting.roundNum / 2) {
                    reminder = setting.roundNum;
                }
                else {
                    reminder = 0;
                }
                break;
            }
            case 'up': {
                reminder = setting.roundNum;
                break;
            }
            case 'down': {
                reminder = 0;
                break;
            }
            default:
                break;
        }
    }
    minutes = rest + reminder;
    var fullHours = "0".concat(Math.floor(minutes / 60)).slice(-2);
    var parsedMinutes = "0".concat(minutes % 60).slice(-2);
    return "".concat(hour.slice(0, 11)).concat(fullHours, ":").concat(parsedMinutes, ":00");
};
exports.applyRounding = applyRounding;
var getNumberOfEmployeesInPackage = function (from, to) {
    var numberOfDays = (0, moment_1.default)(to).diff(from, 'days') + 1;
    var MAX_NUMBER_OF_MAN_DAYS_PER_PACKAGE = 1500;
    return Math.ceil(MAX_NUMBER_OF_MAN_DAYS_PER_PACKAGE / numberOfDays);
};
exports.getNumberOfEmployeesInPackage = getNumberOfEmployeesInPackage;
var splitEmployeesIntoPackages = function (employeeIds, numberOfEmployeesInPackage) {
    return Array.from({
        length: Math.ceil(employeeIds.length / numberOfEmployeesInPackage),
    }).map(function (_, index) {
        var start = index * numberOfEmployeesInPackage;
        var end = start + numberOfEmployeesInPackage;
        var employeeIdsInPackage = employeeIds.slice(start, end);
        return employeeIdsInPackage;
    });
};
exports.splitEmployeesIntoPackages = splitEmployeesIntoPackages;
var mergeRawPayrollData = function (rawPayrollData) {
    return rawPayrollData.reduce(function (acc, data) {
        var _a, _b;
        var relevantEmployeeRows = data.relevantEmployeeRows, totalHours = data.totalHours, totalHoursPlanned = data.totalHoursPlanned, totalHoursReal = data.totalHoursReal, totalNightHours = data.totalNightHours, totalBonuses = data.totalBonuses, totalOvertime50 = data.totalOvertime50, totalOvertime100 = data.totalOvertime100, totalPayout = data.totalPayout, totalAbsences = data.totalAbsences, totalRealization = data.totalRealization, additionalData = data.additionalData;
        var overtime = additionalData.overtime, employeesEmploymentConditions = additionalData.employeesEmploymentConditions, rawOvertime = additionalData.rawOvertime;
        (_a = acc.relevantEmployeeRows).push.apply(_a, __spreadArray([], __read(relevantEmployeeRows), false));
        (_b = acc.additionalData.employeesEmploymentConditions).push.apply(_b, __spreadArray([], __read(employeesEmploymentConditions), false));
        return __assign(__assign({}, acc), { totalHours: acc.totalHours + totalHours, totalHoursPlanned: acc.totalHoursPlanned + totalHoursPlanned, totalHoursReal: acc.totalHoursReal + totalHoursReal, totalNightHours: acc.totalNightHours + totalNightHours, totalBonuses: acc.totalBonuses + totalBonuses, totalOvertime50: acc.totalOvertime50 + totalOvertime50, totalOvertime100: acc.totalOvertime100 + totalOvertime100, totalPayout: acc.totalPayout + totalPayout, totalAbsences: acc.totalAbsences + totalAbsences, totalRealization: acc.totalRealization + totalRealization, additionalData: __assign(__assign({}, acc.additionalData), { overtime: __assign(__assign({}, acc.additionalData.overtime), overtime), rawOvertime: {
                    overtime: __assign(__assign({}, acc.additionalData.rawOvertime.overtime), rawOvertime.overtime),
                } }) });
    }, {
        relevantEmployeeRows: [],
        totalHours: 0,
        totalHoursPlanned: 0,
        totalHoursReal: 0,
        totalNightHours: 0,
        totalBonuses: 0,
        totalOvertime50: 0,
        totalOvertime100: 0,
        totalPayout: 0,
        totalAbsences: 0,
        totalRealization: 0,
        additionalData: {
            overtime: {},
            employeesEmploymentConditions: [],
            rawOvertime: { overtime: {} },
        },
    });
};
exports.mergeRawPayrollData = mergeRawPayrollData;
var mergeRawPayrollLocationData = function (rawPayrollData) {
    return rawPayrollData.reduce(function (acc, data) {
        var _a, _b, _c;
        var relevantEmployeeRows = data.relevantEmployeeRows, additionalData = data.additionalData;
        var overtime = additionalData.overtime, employeesEmploymentConditions = additionalData.employeesEmploymentConditions, employees = additionalData.employees;
        (_a = acc.relevantEmployeeRows).push.apply(_a, __spreadArray([], __read(relevantEmployeeRows), false));
        (_b = acc.additionalData.employeesEmploymentConditions).push.apply(_b, __spreadArray([], __read(employeesEmploymentConditions), false));
        (_c = acc.additionalData.employees).push.apply(_c, __spreadArray([], __read(employees), false));
        return __assign(__assign({}, acc), { additionalData: __assign(__assign({}, acc.additionalData), { overtime: __assign(__assign({}, acc.additionalData.overtime), overtime) }) });
    }, {
        relevantEmployeeRows: [],
        additionalData: {
            overtime: {},
            employeesEmploymentConditions: [],
            employees: [],
        },
    });
};
exports.mergeRawPayrollLocationData = mergeRawPayrollLocationData;
var getSessionKey = function (sessionId) {
    return "payroll_session_".concat(sessionId);
};
exports.getSessionKey = getSessionKey;
var getPayrollSession = function (sessionId, redisController) { return __awaiter(void 0, void 0, void 0, function () {
    var sessionKey, rawBasicData;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                sessionKey = (0, exports.getSessionKey)(sessionId);
                return [4 /*yield*/, redisController.find(sessionKey)];
            case 1:
                rawBasicData = (_a.sent());
                return [2 /*return*/, JSON.parse(rawBasicData)];
        }
    });
}); };
exports.getPayrollSession = getPayrollSession;
var isPayrollLocationAttendance = function (detail) {
    return Boolean(detail.startAtt || detail.endAtt);
};
exports.isPayrollLocationAttendance = isPayrollLocationAttendance;
var isPayrollShift = function (detail) {
    return Boolean(detail.startShift || detail.endShift);
};
exports.isPayrollShift = isPayrollShift;
var isPayrollShiftWithAbsence = function (detail) {
    return Boolean((detail.startShift || detail.endShift) &&
        detail.absence);
};
exports.isPayrollShiftWithAbsence = isPayrollShiftWithAbsence;
var isPayrollOvertimeCollection = function (detail) {
    return detail.isOvertimeCollection;
};
exports.isPayrollOvertimeCollection = isPayrollOvertimeCollection;
var isPayrollAbsence = function (detail) {
    return detail.isAbsence;
};
exports.isPayrollAbsence = isPayrollAbsence;
var isPayrollAvailability = function (detail) {
    return detail.isAvailability;
};
exports.isPayrollAvailability = isPayrollAvailability;
var isPayrollAvailabilityRow = function (row) {
    return 'availability' in row;
};
exports.isPayrollAvailabilityRow = isPayrollAvailabilityRow;
var isPayrollShiftRow = function (row) {
    return 'shift' in row && !('absence' in row) && !('attendance' in row);
};
exports.isPayrollShiftRow = isPayrollShiftRow;
var isPayrollAbsenceRow = function (row) {
    return 'absence' in row && !('shift' in row);
};
exports.isPayrollAbsenceRow = isPayrollAbsenceRow;
var isPayrollShiftAndAbsenceRow = function (row) {
    return 'shift' in row && 'absence' in row && !('attendance' in row);
};
exports.isPayrollShiftAndAbsenceRow = isPayrollShiftAndAbsenceRow;
var isPayrollAttendanceRow = function (row) {
    return 'attendance' in row && !('shift' in row);
};
exports.isPayrollAttendanceRow = isPayrollAttendanceRow;
var isPayrollAttendanceAndShiftRow = function (row) {
    return 'attendance' in row && 'shift' in row && !('absence' in row);
};
exports.isPayrollAttendanceAndShiftRow = isPayrollAttendanceAndShiftRow;
var isPayrollAttendanceShiftAndAbsenceRow = function (row) {
    return 'attendance' in row && 'shift' in row && 'absence' in row;
};
exports.isPayrollAttendanceShiftAndAbsenceRow = isPayrollAttendanceShiftAndAbsenceRow;
